import { create } from 'zustand';

// Cross-component cache of the firm's renewal payment preference (billingApi.getAutoRenewal
// shape). Holds only the value + a synchronous setter — API calls, loading/error state, and
// toast/rollback logic stay in the consuming hook/components (see useRenewalPreference).
const DEFAULT_RENEWAL_PREFERENCE = { enabled: false, paymentMethod: null };

export const useRenewalPreferenceStore = create((set) => ({
  renewalPreference: DEFAULT_RENEWAL_PREFERENCE,
  setRenewalPreference: (value) => set({ renewalPreference: value ?? DEFAULT_RENEWAL_PREFERENCE }),
}));
